import React, { useEffect, useState } from "react";
import Footer from "../component/Footer";
import Header2 from "../component/Header2";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";

function Signup() {

  const redirect = useNavigate();
  const [name, setname] = useState('');
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [mobile, setmobile] = useState('');

  function validation() {
    var ans = true;
    if (name == "") {
      toast.error(" Name Field is required");
      ans = false;
      return false;
    }
    if (email == "") {
      toast.error(" email Field is required");
      ans = false;
      return false;
    }
    if (password == "") {
      toast.error("Password Field is required");
      ans = false;
      return false;
    }
    if (mobile == "") {
      toast.error("Mobile Field is required");
      ans = false;
      return false;
    }

    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('password', password);
      formData.append('mobile', mobile);
      const res = await axios.post(`https://www.rajvicosmeticclinic.com/RajviApi/user_post`, formData, {
        headers: { 'Content-Type': "multipart/form-data" }
      });
      console.log(res);
      if (res.status == 200) {
        toast.success(res.data.message);
        redirect('/login');
      };

    }
  }

  return (
    <>
      <Header2 title="Signup Here" />
      {/* Contact Start */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6" style={{ minHeight: 500 }}>
              <div className="position-relative h-100">
                <iframe
                  className="position-absolute w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
                  frameBorder={0}
                  style={{ border: 0 }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex={0}
                />
              </div>
            </div>
            <div className="col-lg-6 pt-5 pb-lg-5">
              <div className="contact-form bg-light p-4 p-lg-5 my-lg-5">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Signup
                </h6>
                <h1 className="mb-4">Signup Here</h1>

                <form
                  name="sentMessage"
                  id="contactForm"
                  enctype='multipart/form-data'
                  onSubmit={submithandle}
                >
                  <div className="form-row">
                    <div className="col-sm-12 control-group">
                      <input
                        type="text"
                        className="form-control border-0 p-4"
                        id="name"
                        placeholder="Your Name"
                        onChange={(e) => setname(e.target.value)}
                        name="name"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="col-sm-12 control-group">
                      <input
                        type="email"
                        className="form-control border-0 p-4"
                        id="email"
                        placeholder="Your Email"
                        onChange={(e) => setemail(e.target.value)}
                        name="email"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="col-sm-12 control-group">
                      <input
                        type="text"
                        className="form-control border-0 p-4"
                        id="password"
                        placeholder="Your Password"
                        onChange={(e) => setpassword(e.target.value)}
                        name="password"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="col-sm-12 control-group">
                      <input
                        type="number"
                        className="form-control border-0 p-4"
                        id="mobile"
                        placeholder="Your Mobile"
                        onChange={(e) => setmobile(e.target.value)}
                        name="mobile"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    
                    { /*
                    <div className="col-sm-12 control-group">
                      <input
                        type="file"
                        className="form-control border-0 p-4"
                        id="img"
                        placeholder="Your Image"
                        onChange={(e) => setimg(e.target.files[0])}
                        name="img"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    */
                  }   
                  </div>

                  <div>
                    <button
                      className="btn btn-primary py-3 px-4"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Signup
                    </button>
                    <Link to="/login" className="float-right">
                      If you already registered then Login Here
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
      <Footer />
      <Helmet>

        <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.bundle.min.js"></script>
        <script src="lib/easing/easing.min.js"></script>
        <script src="lib/waypoints/waypoints.min.js"></script>
        <script src="lib/counterup/counterup.min.js"></script>
        <script src="lib/owlcarousel/owl.carousel.min.js"></script>
        <script src="lib/tempusdominus/js/moment.min.js"></script>
        <script src="lib/tempusdominus/js/moment-timezone.min.js"></script>
        <script src="lib/tempusdominus/js/tempusdominus-bootstrap-4.min.js"></script>

        <script src="mail/jqBootstrapValidation.min.js"></script>
        <script src="mail/contact.js"></script>

        <script src="js/main.js"></script>
      </Helmet>
    </>
  );
}

export default Signup;
